/**
 * xvi multiple Label component
 */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IFieldPreferences } from '../../form/services';
import { get } from 'lodash';
import { BehaviorSubject, Observable, isObservable, of } from 'rxjs';
import { asObservable } from '@app/shared/utils';
import { ILabel } from '@app/shared/types';

@Component({
  selector: 'xux-multiple-label',
  templateUrl: './xux-multiple-label.component.html',
  styleUrls: ['./xux-multiple-label.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXMultipleLabelComponent implements OnInit {
  @Input() public field: IFieldPreferences;
  public dataObs: BehaviorSubject<ILabel[]> = new BehaviorSubject([]);

  public ngOnInit(): void {
    const data = get(this.field, 'widgetData.data', null);
    this.dataObs = get(this.field, 'widgetData.dataObs', asObservable(data));
  }

  public formateValueToObservable(
    value: string | number | Observable<string | number>,
  ): Observable<string | number> {
    return !isObservable(value) ? of(value) : value;
  }
}
